import { useAuthContext } from '@/context/AuthContext';
import { useOwnerGymProfile } from '@/hooks/useGetOwnerGymProfile';
import Routes from '@/router/Routes';

export function useAuthRedirect() {
  const { user, session, isLoading } = useAuthContext();

  const ownerGymProfile = useOwnerGymProfile(user?.role === 'owner' ? user.id : '');

  const isResolving =
    isLoading ||
    (!!session && !user) ||
    (user?.role === 'owner' && ownerGymProfile.isPending);

  const getRedirectPath = (): string => {
    if (!user) return Routes.GYMS;

    switch (user.role) {
      case 'goer':
        return Routes.GYMS;
      case 'owner':
        return ownerGymProfile.data ? Routes.OWNER_LISTING_STATUS : Routes.OWNER_ONBOARDING;
      case 'admin':
        return Routes.ADMIN_GYM_GOERS;
      default:
        return Routes.GYMS;
    }
  };

  return { redirectPath: getRedirectPath(), isResolving };
}
